import React from 'react'
import Layout from '../components/layout'
import { StaticImage } from "gatsby-plugin-image"

const DetailedStories = () => {

    return (
        <Layout pageTitle='Success Stories - Dochase Adx' >
            <div className='text-[#4F4F4F] pt-12 lg:pt-24'>
                <div className='lg:max-w-[1440px] mx-auto'>
                    <section className='w-full'>
                        <div className='mt-8 lg:mt-16 mx-[7%] lg:mx-[15%]'>
                            <p className='font-bold text-3xl lg:text-6xl text-center leading-9 lg:leading-[73px]'>Success stories of some of our happy clients.</p>
                            <p className='font medium text-lg lg:text-2xl text-center mt-5 lg:mt-11 mx-[5%] lg:mx-[10%]'>We always deliver on our goals and that is why we are trusted by several brands across different sectors to deliver on their business needs.</p>
                        </div>
                    </section>
                </div>

                <section className='pt-16 lg:pt-32' id='fcmb'>
                    <div className='bg-[#f9253908] w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[10%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/fcmb.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>FCMB</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>FCMB reached out to us to create awareness and drive consistent engagement for their brand.
                                        We then created a strategic awareness campaign that seamlessly merged FCMB's aspirations with our expertise in delivering impactful advertising solutions.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Our strategic approach involved leveraging over 100 sites and apps across Nigeria's key cities – Lagos, Port-Harcourt, and Abuja – to engage a diverse audience ranging from 18 to 70 years. Our targeted campaign covered both mobile and desktop devices, catering to Android, iOS, Mac, and Windows Phone operating systems. The 3-week duration ensured a comprehensive reach, of both the male and female demographics.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>3x ROI on Ad spend</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>95% lift in Brand Awareness</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='budweiser'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[10%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/budweiser.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Budweiser</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>To create a strong awareness for the Budweiser Smooth King remix and to also deepen Budweiser’s penetration in the markets it seeks to serve.
                                        The aim was to drive engagement which will lead to an increase in view rates of the show and also in sales</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>The campaign was strategically deployed across a diverse range of over 200 sites and apps, effectively targeting Nigeria's prominent cities (as advised by the client) – Lagos, Port-Harcourt, and Abuja. With a focus on the 18 to 50 age bracket, our campaign leveraged mobile devices, like Android, iOS, and Windows Phone. Our messaging resonated with both male and female audiences, achieving impactful results within a concise span of 4 days.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>2x ROI on Ad spend</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>98% lift in Brand Awareness</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='tecno'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[10%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/tecno.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Tecno</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Tecno reached out to us to reinforce in the minds of their target audience the exceptional quality of their mobile devices. They also wanted to drive sales and boost their competitive stance among rival brands in Nigeria.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>We engaged with a number of platforms, including over 200 sites and apps, alongside a robust SMS campaign with 20K+ tags. We focused on Nigeria's prominent cities – Lagos, Port-Harcourt, and Abuja – reaching a wide demographic range spanning from 15 to 70 years. Our precise targeting revolved around mobile phones like Android, iOS, and Windows Phone operating systems. This campaign spanned an impressive 6-month duration.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>3x ROI on Ad spend</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>85% lift in Ad Recal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='peak'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[10%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/peak.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Peak</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Peak’s aim was to enhance brand visibility and sustain meaningful engagement, so we went ahead to create a strategic awareness campaign that aligned with their goals.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Using an array of platforms, including over 200 sites and apps, we strategically covered every state in Nigeria. We deployed the campaign using different interactive Rich media creatives for better interaction with the target audience. Our audience range spanned from 18 to 60 years, ensuring a comprehensive reach across mobile and desktop devices. The operating systems targeted were Android, Mac, iOS, and Windows Phone.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>5x ROI on Ad spend</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>90% lift in Ad Recal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='bitmama'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[10%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/bitmama.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Bitmama</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>As a crypto app, the brand could not freely advertise to onboard users via online channels because of regulations, they required advertising for user acquisition and to increase brand awareness.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>We used Data-powered media buying, and programmatic advertising platforms with global reach and superior targeting. We Leveraged the Dochase Google API partnership to unlock audience on millions of sites on Google, YouTube and more. Targeting people who are interested in Digital currency, Technology, crypto information and Exchange, we used retargeting pixels to reach people who had previously engaged with the ad.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-6'>
                                            <p>3x ROI on Ad spend</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-6'>
                                            <p>94% traffic round the app</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-6'>
                                            <p>7,824 installs</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='flutterwave'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[12%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/flutterwave.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Flutterwave</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>They needed small businesses in Nigeria, Kenya, Ghana, and Rwanda to register on their platforms and their key passion points included people who sell on Instagram, WhatsApp and Facebook, mom-and-pop online sellers, brick-and-mortar businesses that want to digitize</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>The brand wanted 50,000 Merchants and this was achieved by using a combination of creativity, multiple platforms, and technology. We leveraged rich media, static banners, text ads and video ads and changed banners weekly depending on the response on each banner.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>7x Incremental lift in sales</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>50k Registrations</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='apex'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[12%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/apex.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Apex</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Apex, a Cryptocurrency financial servicing firm required advertising to increase brand awareness and account registrations.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Leveraging our programmatic data we narrowed down the brand’s audience and targeted them on behavioural and location parameters using their favourite communication medium (Sites and Apps). We also ensured each unique target is served ads at least 3 times to aid brand recall.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>3x ROI on Ad spend</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>3.6k+ Account Registrations</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='bet9ja'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[12%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/bet9ja.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Bet9ja</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Bet9ja wanted to increase brand awareness amongst its target audience in Nigeria increase market share and onboard new users.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>We studied our demography and combined different ad formats leveraging targeting parameters specific to the brand and the users it wanted to onboard. We also then retargeted interested audiences with storytelling to increase sign-ups.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>85% Increase in Engagements</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>8k+ Signups</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-7 lg:pt-14' id='nosh'>
                    <div className='w-full pt-5 lg:pt-10 pb-16 lg:pb-32'>
                        <div className='lg:max-w-[1440px] mx-auto'>
                            <div className='mx-[6%] lg:mx-[12%]'>
                                <div className='flex'>
                                    <StaticImage
                                        src="../images/nosh.png"
                                        alt='dashboard'
                                        placeholder="blurred"
                                        quality="100"
                                    />
                                    <p className='text-xl lg:text-3xl font-bold ml-4 my-auto'>Nosh</p>
                                </div>

                                <div className='mt-7 lg:mt-14'>
                                    <p className='text-xl lg:text-3xl font-bold'>The Campaign Objective</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Nosh is the home to gaming, streaming, and supermarket gift cards. Integrated with utilities and bill payment.  The platform sought to amplify brand recognition and expand its user base through strategic advertising.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Our Approach</p>
                                    <p className='mt-2 lg:mt-4 text-base lg:text-xl'>Leveraging our programmatic data expertise, we meticulously refined the brand's target audience and engaged them through precise behavioural and location-based targeting across their preferred communication channels, encompassing various sites and apps.</p>
                                </div>

                                <div className='mt-6 lg:mt-12'>
                                    <p className='text-xl lg:text-3xl font-bold'>Campaign Results</p>
                                    <div className='flex space-x-4 lg:space-x-8 text-white text-xl lg:text-3xl font-black mt-2.5 lg:mt-5'>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>90% Increase in Engagements</p>
                                        </div>
                                        <div className='bg-[#00C28B] rounded-[10px] py-6 px-8'>
                                            <p>3k+ Signups</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    )
}

export default DetailedStories